import controller from './order-detail.controller';
import templateBase from './templates/order-detail-base.view.html';
import templateT15 from './templates/order-detail-t15.view.html';
import templateAD from './templates/order-detail-adaptative.html';

let OrderDetailComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');

    if(__env.adaptative) {
        return templateAD;
    } else { 
        if (response.ORDER_DETAIL.component == 'template_t15') { return templateT15; }
        else {
          return templateBase;
        }
    }
}

export default OrderDetailComponent;


// WEBPACK FOOTER //
// ./www/components/orders/order-detail/order-detail.component.js